module.exports = __webpack_public_path__ + "static/media/film-production-grid-1.c135d864.jpg";